import {Point} from 'util/geometry/GeometryConstants';

/**
 * Adjust a position to the nearest grid point in a snap grid.
 *
 * @param position - The position to adjust.
 * @param snapGrid - The snap grid to use.
 * @returns The adjusted position.
 */
export function snapPositionToGrid(position: Point, snapGrid: [number, number]): Point {
  const [xSnapGrid, ySnapGrid] = snapGrid;
  return {
    x: Math.round(position.x / xSnapGrid) * xSnapGrid,
    y: Math.round(position.y / ySnapGrid) * ySnapGrid,
  };
}
